import { useTranslation } from "react-i18next";

import type { MessageData } from "api/services/messaging/schemas/messaging";
import { useLocalizedDate } from "utils/date";

import { SystemMessage } from "./SystemMessage";

interface PatientAssignmentChangeMessageProps {
  message_data: MessageData;
}

export const PatientAssignmentChangeMessage: React.FC<PatientAssignmentChangeMessageProps> = ({ message_data }) => {
  const { t } = useTranslation();
  const { format, isValid, parseISO } = useLocalizedDate();
  const therapistName = `${message_data.previously_active_therapist?.first_name} ${message_data.previously_active_therapist?.last_name}`;

  const getSubstituteTherapistMessage = () => {
    const isAssignmentStarting = message_data.change === "assignment_started";

    if (isAssignmentStarting) {
      if (message_data.assignment_end_date && isValid(message_data.assignment_end_date)) {
        return t("messages.substitute_therapist_change.start_with_end_date", {
          therapistName,
          assignmentEndDate: format(parseISO(message_data.assignment_end_date), "PP"),
        });
      }

      return t("messages.substitute_therapist_change.start", { therapistName });
    }

    return t("messages.substitute_therapist_change.end", { therapistName });
  };

  return (
    <SystemMessage
      body={
        message_data.assignment_role === "substitute_therapist"
          ? getSubstituteTherapistMessage()
          : t("messages.main_therapist_change", { therapistName })
      }
    />
  );
};
